import React from 'react';
import { T } from '../../utils/adminTheme';

const Datenschutz: React.FC<{ onClose?: () => void }> = ({ onClose }) => (
  <div style={{ minHeight: '100vh', background: T.bg, color: T.text }}>
    <div style={{ maxWidth: 740, margin: '0 auto', padding: '40px 20px 80px' }}>
      <button
        onClick={onClose ?? (() => window.history.back())}
        style={{
          background: 'none', border: `1px solid ${T.line}`,
          borderRadius: 999, padding: '6px 16px',
          fontFamily: T.body, fontSize: 13, color: T.muted,
          cursor: 'pointer', marginBottom: 32,
        }}
      >
        ← Zurück
      </button>

      <h1 style={{ fontFamily: T.display, fontStyle: 'italic', fontSize: 36, fontWeight: 500, marginBottom: 8 }}>
        Datenschutzerklärung
      </h1>
      <p style={{ fontFamily: T.body, fontSize: 13, color: T.muted, marginBottom: 40 }}>
        Stand: Mai 2026 · Traum Beauty Cakar, Zürich
      </p>

      {[
        {
          title: '1. Verantwortliche Stelle',
          body: `Traum Beauty Cakar\nZürich, Schweiz\nE-Mail: [IHRE E-MAIL]\nTelefon: [IHRE TELEFONNUMMER]\n\nFür Fragen zum Datenschutz wenden Sie sich bitte direkt an uns.`,
        },
        {
          title: '2. Welche Daten wir erheben',
          body: `Bei der Online-Terminbuchung erheben wir:\n• Name\n• E-Mail-Adresse\n• Telefonnummer\n• Datum und Uhrzeit des gewünschten Termins\n• Gebuchte Behandlung und Standort\n• Freiwillige Anmerkungen\n\nWir erheben keine Daten über nicht buchende Website-Besucher.`,
        },
        {
          title: '3. Zweck der Datenverarbeitung',
          body: `Ihre Daten werden ausschließlich verwendet für:\n• Bestätigung und Verwaltung Ihres Termins\n• Erinnerungsnachrichten vor dem Termin\n• Stornierung auf Ihren Wunsch\n\nWir geben Ihre Daten nicht an Dritte weiter.`,
        },
        {
          title: '4. Rechtsgrundlage',
          body: `Die Verarbeitung erfolgt auf Grundlage Ihrer ausdrücklichen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sowie zur Erfüllung des Buchungsvertrags (Art. 6 Abs. 1 lit. b DSGVO).`,
        },
        {
          title: '5. Speicherdauer',
          body: `Buchungsdaten werden für 3 Jahre nach dem Termin gespeichert, danach gelöscht. Sie können jederzeit die Löschung Ihrer Daten verlangen.`,
        },
        {
          title: '6. Ihre Rechte',
          body: `Sie haben das Recht auf:\n• Auskunft über Ihre gespeicherten Daten\n• Berichtigung unrichtiger Daten\n• Löschung Ihrer Daten\n• Widerruf Ihrer Einwilligung\n• Beschwerde bei der Datenschutzbehörde\n\nFür alle Anfragen: [IHRE E-MAIL]`,
        },
        {
          title: '7. Datensicherheit',
          body: `Alle Daten werden verschlüsselt über HTTPS übertragen und sicher in der EU-Schweiz bei Supabase (ISO 27001 zertifiziert) gespeichert.`,
        },
        {
          title: '8. Cookies',
          body: `Diese Website verwendet keine Tracking-Cookies. Es werden nur technisch notwendige Sitzungsdaten gespeichert.`,
        },
      ].map(({ title, body }) => (
        <section key={title} style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: T.body, fontSize: 16, fontWeight: 700, marginBottom: 10, color: T.text }}>
            {title}
          </h2>
          <p style={{ fontFamily: T.body, fontSize: 14, lineHeight: 1.7, color: T.text, whiteSpace: 'pre-line', margin: 0 }}>
            {body}
          </p>
        </section>
      ))}

      <div style={{
        marginTop: 48, padding: 18, background: T.surface,
        border: `1px solid ${T.line}`, borderRadius: 12,
        fontFamily: T.body, fontSize: 13, color: T.muted, lineHeight: 1.6,
      }}>
        ⚠️ <strong style={{ color: T.text }}>Hinweis:</strong> Diese Datenschutzerklärung ist eine Vorlage und muss vor dem Go-Live von einem Rechtsanwalt geprüft und auf Ihr Unternehmen angepasst werden. Ersetzen Sie alle <strong>[PLATZHALTER]</strong> mit Ihren echten Angaben.
      </div>
    </div>
  </div>
);

export default Datenschutz;
